<template>
  <div v-if="!$device.isMobile" class="register-bonuses__buttons">
    <button
      class="register-bonuses__slider-nav-btn register-bonuses__prev"
      :data-gtm-id="`${$options.static.GTM_REG_BONUS.ID.ga_deposite_click_btn_prev_bonus}${gtmAbTestId}`"
    >
      <SvgIcon class="register-bonuses__slider-nav-btn-icon" name="chevrons/chevron-left" />
    </button>
    <button
      class="register-bonuses__slider-nav-btn register-bonuses__next"
      :data-gtm-id="`${$options.static.GTM_REG_BONUS.ID.ga_deposite_click_btn_next_bonus}${gtmAbTestId}`"
    >
      <SvgIcon class="register-bonuses__slider-nav-btn-icon" name="chevrons/chevron-right" />
    </button>
  </div>
</template>

<script>
import { GTM_REG_BONUS } from '~/constants/gtm'
export default {
  name: 'RegistrationBonusSliderButtons',
  static: { GTM_REG_BONUS },
  computed: {
    gtmAbTestId() {
      return this.$ab().new ? '' : 'v2'
    },
  },
}
</script>

<style lang="scss" scoped>
  .register-bonuses {
    &__buttons {
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
    }
    
    &__slider-nav-btn {
      position: absolute;
      top: 0;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 72px;
      height: 72px;
      color: var(--secondary-100);
      background-color: var(--general-bg-navi);
      border: none;
      border-radius: 50%;
      
      &.swiper-button-disabled {
        display: none;
      }
    }
    
    &__slider-nav-btn-icon {
      display: flex;
      width: 56px;
      height: 56px;
      padding: 16px;
      border: solid 1px var(--button-line-border-default);
      border-radius: 50%;
    }
    
    &__prev {
      right: calc(50% + 64px + var(--card__w) / 2);
    }
    
    &__next {
      left: calc(50% + 64px + var(--card__w) / 2);
    }
  }
</style>
